// TODO: rename this file to Dropdown.jsx after the other one isn't used anymore and removed

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Dropdown, Input } from 'antd'
import cloneDeep from 'lodash/cloneDeep'
import classNames from 'classnames'
import isEqual from 'lodash/isEqual'

import Icon from 'components/Icon'
import Content from './Content'

import './index.less'

const mapStateToProps = (state) => ({
  layout: state.layout,
})

class AntDropdown extends React.PureComponent {
  skipBlur = false

  constructor (props) {
    super(props)

    this.state = {
      opened: false,
      filteredSegments: props.segments,
      activeOptionsCount: 0,
      lastInputValue: '',
      hasAutocompleteForeshadow: false,
      displayedValue: '',
      flattenedOptionsList: [],
      selectedIndex: null,
      userSelectionActive: false,
    }

    this.ref = null
    this.inputRef = null
    this.dropdownRef = null
    this.addonAfterRef = null
    this.filterTimeout = null
  }

  componentWillUnmount () {
    document.removeEventListener('click', this._domClick)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  componentDidMount () {
    this.setCurrentValues(this.props)
  }

  componentDidUpdate (prevProps, _prevState) {
    if (this.props.segments !== prevProps.segments) {
      this.setCurrentValues(this.props)

      this.setState({
        filteredSegments: this.props.segments,
      })
    }
  }

  clearFilter = () => {
    this.props.segments.forEach((segment) => {
      this.handleFilterChange('', segment)
    })
  }

  openDropdown = (event) => {
    const {
      disabled,
      hasFilterInput,
      onOpen,
    } = this.props

    const {
      hasEventHandlers,
      opened,
    } = this.state

    if (opened || disabled) { return }

    if (hasFilterInput) {
      this.inputRef.input.select()
    }

    this.setState({
      opened: true,
    })

    // stop propagation to now trigger _domClick handler
    if (event && event.type === 'click') { event.stopPropagation() }

    if (!hasEventHandlers) {
      document.addEventListener('click', this._domClick)
      document.addEventListener('keydown', this.onKeyDown)

      this.setState({ hasEventHandlers: true })
    }

    onOpen()
  }

  closeDropdown = () => {
    if (this.state.opened) {
      this.setState({
        opened: false,
        hasEventHandlers: false,
        userSelectionActive: false,
      })

      document.removeEventListener('click', this._domClick)
      document.removeEventListener('keydown', this.onKeyDown)
    }
  }

  isCurrentOption = (option, segment) => {
    if (segment.currentValue && typeof segment.currentValue === 'object') {
      return (segment.currentValue.indexOf(option.id) !== -1)
    } else {
      return (option.id && option.id === segment.currentValue)
    }
  }

  setCurrentValues = () => {
    const {
      segments,
      countOnlyOneFilter,
    } = this.props

    const currentValues = []
    let activeOptionsCount = 0

    const setValueIfCurrentOption = (option, segment) => {
      if (this.isCurrentOption(option, segment)) {
        currentValues.push(option)
        activeOptionsCount++
      }
    }

    segments.forEach((segment, _segmentIndex) => {
      segment.options.forEach((option, _optionIndex) => {
        if (option.children) {
          option.children.forEach((childOption, _childIndex) => {
            setValueIfCurrentOption(childOption, segment)
          })
        } else {
          setValueIfCurrentOption(option, segment)
        }
      })
    })

    if (countOnlyOneFilter && activeOptionsCount > 1) {
      activeOptionsCount = 1
    }

    const displayedValue = currentValues.length ? currentValues.map((currentValue) => currentValue.text).join(', ') : ''

    if (this.inputRef) {
      this.inputRef.setValue(displayedValue, { ignore: true })
    }

    this.setState({
      activeOptionsCount,
      displayedValue,
    })

    this.buildFlattenedOptionsList(segments)
  }

  isOptionMatching = (option, filterValue, beginsWithFilter) => {
    let indexValue

    if (typeof option.text === 'string') {
      indexValue = option.text.toLowerCase().indexOf(filterValue.trim())
    }

    return beginsWithFilter ? (indexValue === 0) : (indexValue >= 0)
  }

  filterOptions = (options, beginsWithFilter, filterValue, filterByOptgroups, matchingOptgroupIds) => {
    let allMatchingChildren = []

    const filteredOptions = options.filter((option) => {
      if (filterByOptgroups && matchingOptgroupIds.includes(option.id)) {
        return true
      }

      if (option.children) {
        const filterOptions = this.filterOptions(option.children, beginsWithFilter, filterValue)

        option.children = filterOptions.filteredOptions
        allMatchingChildren = allMatchingChildren.concat(option.children)

        return option.children.length >= 1
      } else {
        if (this.isOptionMatching(option, filterValue, beginsWithFilter)) {
          allMatchingChildren.push(option.text)

          return true
        }

        return false
      }
    })

    return {
      filteredOptions,
      allMatchingChildren,
    }
  }

  filterOptionGroups = (options, beginsWithFilter, filterByOptgroups, filterValue) => {
    const matchingOptgroupIds = []

    if (filterByOptgroups) {
      options.forEach((option) => {
        if (this.isOptionMatching(option, filterValue, beginsWithFilter)) {
          matchingOptgroupIds.push(option.id)
        }
      })
    }

    return this.filterOptions(options, beginsWithFilter, filterValue, filterByOptgroups, matchingOptgroupIds)
  }

  filterSegments = (event, autocomplete = false) => {
    const input = this.inputRef.input
    const filterValue = input.value.toLowerCase()

    const filteredSegments = cloneDeep(this.props.segments)

    if (filterValue) {
      filteredSegments.forEach((segment, _segmentIndex) => {
        const filterOptions = this.filterOptionGroups(
          segment.options,
          segment.beginsWithFilter,
          segment.filterByOptgroups,
          filterValue,
        )

        segment.options = filterOptions.filteredOptions

        const cursorPosition = input.selectionStart

        if (
          autocomplete &&
          cursorPosition >= 2 &&
          filterOptions.allMatchingChildren.length >= 1 &&
          segment.beginsWithFilter
        ) {
          let firstChildValue

          if (segment.autocompleteMatchBegin) {
            const beginMatchChild = filterOptions.allMatchingChildren.find(matchingChildren => (
              matchingChildren.toLowerCase().startsWith(filterValue.toLowerCase())
            ))

            if (beginMatchChild) {
              firstChildValue = beginMatchChild
            }
          } else {
            firstChildValue = filterOptions.allMatchingChildren[0]
          }

          if (firstChildValue) {
            this.inputRef.setValue(firstChildValue, { ignore: true })

            if (event && event.type !== 'blur') {
              window.requestAnimationFrame(() => input.setSelectionRange(cursorPosition, input.value.length))
            }
          }

          this.setState({
            hasAutocompleteForeshadow: true,
          })

          this.filterSegments(event, false)
        }
      })
    }

    this.setState({
      filteredSegments,
      selectedIndex: null,
    }, () => {
      this.buildFlattenedOptionsList(filteredSegments)
    })

    return filteredSegments
  }

  _domClick = (event) => {
    const {
      addonAfterRef,
      closeDropdown,
      dropdownRef,
    } = this

    // click outside the dropdown or in the arrow inside the dropdown
    if (
      (dropdownRef && !dropdownRef.contains(event.target)) ||
      (addonAfterRef && addonAfterRef.contains(event.target))
    ) {
      closeDropdown()
    }
  }

  handleFilterChange = (value, segment, closeDropdown) => {
    this.props.onChange({ [segment.name]: value })

    if (closeDropdown) {
      this.closeDropdown()
    }
  }

  handleLinkClick = (event, value, segment, closeDropdown) => {
    if (this.props.onlyUpdateFilters) {
      event.preventDefault()
    }

    this.handleFilterChange(value, segment, closeDropdown)
  }

  handleItemMouseDown = () => {
    this.skipBlur = true
  }

  handleItemMouseUp = () => {
    this.skipBlur = false
  }

  getChildOptions = (options) => {
    let childOptions = []

    options.forEach((option) => {
      if (option.children) {
        childOptions = childOptions.concat(this.getChildOptions(option.children))
      } else {
        childOptions.push(option)
      }
    })

    return childOptions
  }

  applyFilter = (event, forcedOption) => {
    const input = this.inputRef.input
    const endOfInput = input.value.length

    this.setState({
      hasAutocompleteForeshadow: false,
    })

    if ((event && event.key !== 'Enter') || this.state.userSelectionActive) {
      return
    }

    if (event && event.type !== 'blur') {
      input.setSelectionRange(endOfInput, endOfInput)
    }

    const filteredSegments = this.filterSegments(event)

    let lastCurrentValue
    let nextOption = forcedOption

    if (!nextOption) {
      filteredSegments.forEach((segment) => {
        lastCurrentValue = segment.currentValue

        const childOptions = this.getChildOptions(segment.options)

        if (childOptions.length === 1) {
          nextOption = {
            segment: {
              name: segment.name,
              type: segment.type,
            },
            option: childOptions[0],
          }
        }
      })
    }

    if (nextOption) {
      let filterValue = nextOption.option.id

      if (nextOption.segment.type === 'checkboxes' && lastCurrentValue) {
        filterValue = lastCurrentValue.splice(0)

        const index = filterValue.indexOf(nextOption.option.id)

        if (index !== -1) {
          filterValue.splice(index, 1)
        } else {
          filterValue.push(nextOption.option.id)
        }
      }

      this.handleFilterChange(filterValue, nextOption.segment)

      if (nextOption.option.href) {
        const url = this.props.urlTransformer(nextOption.option.href)

        if (url.indexOf('//') !== -1) {
          window.location.href = url
        } else {
          this.props.pushRoute(url)
        }
      }

      this.closeDropdown()
    }
  }

  renderNativeSelect = (segment) => {
    if (!segment.options.length) { return false }

    return (
      <select
        className="dropdown__native-select"
        value={segment.currentValue || ''}
        onChange={(event) => {
          this.props.onChange({ [segment.name]: this.parseIfInt(event.target.value) })
        }}
      >
        {!segment.currentValue && <option />}

        {segment.options.map((option, index) => this.renderNativeSelectOption(option, index))}
      </select>
    )
  }

  renderNativeSelectOption = (option, index) => {
    if (option.id) {
      return (
        <option key={index} value={this.parseIfInt(option.id)}>
          {option.text}
        </option>
      )
    }

    if (option.children) {
      return (
        <optgroup key={index} label={option.text}>
          {option.children.map((option, index) => this.renderNativeSelectOption(option, index))}
        </optgroup>
      )
    }
  }

  renderIconAfter = (filterShouldBeCleared, displayNumberBadge) => {
    const showOnlyWhenFiltered = this.props.showOnlyWhenFiltered
    const activeOptionsCount = this.state.activeOptionsCount

    if (showOnlyWhenFiltered) { return }

    let icon

    if (filterShouldBeCleared) {
      icon = 'close'
    } else if (this.state.opened) {
      icon = 'angle-up'
    } else {
      icon = 'angle-down'
    }

    return (
      <div
        onClick={(event) => { filterShouldBeCleared ? this.clearFilter() : this.openDropdown(event) }}
        ref={(ref) => { this.addonAfterRef = ref }}
      >
        {displayNumberBadge && (
          <div className="number-badge number-badge--small">
            {activeOptionsCount}
          </div>
        )}

        <Icon name={icon} />
      </div>
    )
  }

  parseIfInt = (value) => {
    return isNaN(value) ? value : parseInt(value)
  }

  click = () => {
    return this.inputRef.input.click()
  }

  onFocus = (event) => {
    if (event.target.tagName === 'INPUT' && !this.props.hasFilterInput) {
      event.target.blur()
    }

    if (!this.props.isMsie) {
      this.openDropdown()
    }
  }

  onChange = (event) => {
    if (event.ignore) {
      return false
    }

    const inputValue = this.inputRef.input.value
    const keysEntered = inputValue.length > this.state.lastInputValue.length

    if (this.props.filterSegmentsWithTimeout) {
      window.clearTimeout(this.filterTimeout)
      this.filterTimeout = window.setTimeout(() => {
        this.filterSegments(event, keysEntered)
      }, 500)
    } else {
      this.filterSegments(event, keysEntered)
    }

    this.setState({
      lastInputValue: inputValue,
    })
  }

  resetAutocompleteForeshadow = () => {
    this.setState({
      hasAutocompleteForeshadow: false,
    })
  }

  handleArrowKeyDown = (event, keyCode) => {
    const {
      flattenedOptionsList,
      selectedIndex,
    } = this.state

    let nextSelectedIndex = 0

    if (selectedIndex !== null) {
      event.preventDefault()

      if (keyCode === 40) { // ArrowDown
        nextSelectedIndex = (selectedIndex === flattenedOptionsList.length - 1) ? 0 : selectedIndex + 1
      } else if (keyCode === 38) { // ArrowUp
        nextSelectedIndex = (selectedIndex === 0) ? flattenedOptionsList.length - 1 : selectedIndex - 1
      }
    }

    this.setState({
      selectedIndex: nextSelectedIndex,
      userSelectionActive: true,
    })
  }

  onKeyDown = (event) => {
    const {
      flattenedOptionsList,
      lastInputValue,
    } = this.state

    if (this.props.isMsie) { return }

    const keyCode = event.keyCode

    if (keyCode === 40 || keyCode === 38) { // ArrowDown, ArrowUp
      this.handleArrowKeyDown(event, keyCode)
    } else if (keyCode === 13) { // Enter
      const selectedOption = this.getSelectedOption()

      let emptyOption

      if (lastInputValue === '') {
        emptyOption = flattenedOptionsList.find((option) => option.optionId === '')
      }

      if (emptyOption) {
        this.handleFilterChange(emptyOption.optionId, { name: emptyOption.segmentName }, true)

        this.applyFilter(event, {
          segment: {
            name: emptyOption.segmentName,
          },
          option: {
            id: emptyOption.optionId,
            href: emptyOption.optionHref,
          },
        })
      } else if (selectedOption) {
        this.handleFilterChange(selectedOption.optionId, { name: selectedOption.segmentName }, true)

        this.applyFilter(event)
      }
    } else if (keyCode === 9) { // Tab
      this.closeDropdown()
    }
  }

  getSelectedOption = () => {
    const {
      flattenedOptionsList,
      selectedIndex,
    } = this.state

    return selectedIndex !== null ? flattenedOptionsList[selectedIndex] : null
  }

  buildFlattenedOptionsList = (filteredSegments) => {
    const flattenedOptionsList = []
    let selectedValue = null

    const pushToFlattenedOptionsList = (option, segment) => {
      const flattenedOption = {
        segmentName: segment.name,
        optionId: option.id,
        optionHref: option.href,
      }

      if (this.isCurrentOption(option, segment)) {
        selectedValue = flattenedOption
      }

      flattenedOptionsList.push(flattenedOption)
    }

    filteredSegments.forEach((segment, _segmentIndex) => {
      segment.options.forEach((option, _optionIndex) => {
        if (option.children) {
          option.children.forEach((childOption, _childIndex) => {
            pushToFlattenedOptionsList(childOption, segment)
          })
        } else {
          pushToFlattenedOptionsList(option, segment)
        }
      })
    })

    const selectedIndex = selectedValue
      ? flattenedOptionsList.findIndex((option) => isEqual(option, selectedValue))
      : this.state.selectedIndex

    this.setState({
      flattenedOptionsList,
      selectedIndex,
      hasNoEntries: flattenedOptionsList.length === 0,
    })
  }

  setSelectedIndex = (segmentName, optionId) => {
    const {
      flattenedOptionsList,
    } = this.state

    const selectedValue = {
      segmentName,
      optionId,
    }

    const selectedIndex = flattenedOptionsList.findIndex((option) => isEqual(option, selectedValue))

    this.setState({
      selectedIndex,
      userSelectionActive: true,
    })
  }

  onBlur = (event) => {
    event.preventDefault()
    const { selectFirstMatchOnBlur } = this.props

    this.resetAutocompleteForeshadow()

    if (selectFirstMatchOnBlur && !this.skipBlur) {
      this.applyFilter(event)
      const filteredSegments = this.filterSegments(event)

      const input = this.inputRef.input

      if (filteredSegments.length === 1 &&
        filteredSegments[0].options.length >= 1 &&
        filteredSegments[0].beginsWithFilter &&
        input.value.length >= 2
      ) {
        const nextSegment = filteredSegments[0]
        const nextOption = nextSegment.options[0]

        this.handleFilterChange(nextOption.id, nextSegment, true)
      }
    }
  }

  render () {
    const {
      layout,
      size,
      placeholder,
      icon,
      disabled,
      showNumberBadge,
      hasFilterInput,
      label,
      useNativeSelectOnMobile,
      segments,
      showOnlyWhenFiltered,
      noEntriesText,
      pagination,
      Link,
      urlTransformer,
      inputProps,
    } = this.props

    const {
      filteredSegments,
      activeOptionsCount,
      userSelectionActive,
      lastInputValue,
    } = this.state

    const displayNumberBadge = showNumberBadge && activeOptionsCount > 0

    const filterShouldBeCleared = this.props.clearFilterOnOpen && this.state.activeOptionsCount > 0

    const hideWithoutFilter = showOnlyWhenFiltered && !lastInputValue

    const content = (
      <Content
        filteredSegments={filteredSegments}
        handleFilterChange={this.handleFilterChange}
        handleLinkClick={this.handleLinkClick}
        handleItemMouseDown={this.handleItemMouseDown}
        handleItemMouseUp={this.handleItemMouseUp}
        selectedOption={this.getSelectedOption()}
        userSelectionActive={userSelectionActive}
        setSelectedIndex={this.setSelectedIndex}
        hasNoEntries={this.state.hasNoEntries}
        noEntriesText={noEntriesText}
        pagination={pagination}
        Link={Link}
        urlTransformer={urlTransformer}
      />
    )

    const wrapperClasses = classNames(
      'dropdown__wrapper',
      this.props.className,
      { [`dropdown__wrapper--${size}`]: size },
    )

    return (
      <div className={wrapperClasses}>
        {label && <label>{label}</label>}

        <Dropdown
          overlay={content}
          visible={!hideWithoutFilter && this.state.opened}
          getPopupContainer={(triggerNode) => {
            this.dropdownRef = triggerNode

            return triggerNode
          }}
          disabled={disabled}
        >
          <Input
            autoComplete="nope" // enforcing non-autocompletion by assigning an invalid value to the attribute
            {...inputProps}
            ref={(ref) => { this.inputRef = ref }}
            className={classNames('dropdown-input', {
              'dropdown-input--with-icon': icon,
              'dropdown-input--with-number-badge': displayNumberBadge,
              'dropdown-input--with-filter': hasFilterInput,
              'dropdown-input--autocomplete-foreshadow': this.state.hasAutocompleteForeshadow,
              'dropdown-input--without-arrow': !this.addonAfterRef,
            })}
            placeholder={placeholder}
            addonBefore={icon ? <div onClick={this.openDropdown}><Icon name={icon} /></div> : undefined}
            addonAfter={this.renderIconAfter(filterShouldBeCleared, displayNumberBadge)}
            size={size}
            onClick={(event) => {
              if (filterShouldBeCleared) {
                this.clearFilter()
              }
              this.openDropdown(event)
            }}
            onChange={this.onChange}
            onKeyDown={this.applyFilter}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            tabIndex={hasFilterInput ? '0' : '-1'}
          />
        </Dropdown>

        {!hasFilterInput && (
          <div
            className="dropdown__focus-input-replacement"
            onFocus={this.onFocus}
            onBlur={this.closeDropdown}
            tabIndex="0"
          />
        )}

        {
          useNativeSelectOnMobile &&
          layout.mobile &&
          segments.length === 1 &&
          !disabled &&
          this.renderNativeSelect(segments[0])
        }
      </div>
    )
  }
}

AntDropdown.propTypes = {
  layout: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  hasFilterInput: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  segments: PropTypes.array.isRequired,
  showNumberBadge: PropTypes.bool,
  onlyUpdateFilters: PropTypes.bool,
  countOnlyOneFilter: PropTypes.bool,
  error: PropTypes.string,
  useNativeSelectOnMobile: PropTypes.bool,
  filterSegmentsWithTimeout: PropTypes.bool,
  clearFilterOnOpen: PropTypes.bool,
  showOnlyWhenFiltered: PropTypes.bool,
  onOpen: PropTypes.func,
  noEntriesText: PropTypes.string,
  selectFirstMatchOnBlur: PropTypes.bool,
  pagination: PropTypes.bool,
  pushRoute: PropTypes.func.isRequired,
  Link: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  urlTransformer: PropTypes.func,
  isMsie: PropTypes.bool,
  inputProps: PropTypes.object,
}

AntDropdown.defaultProps = {
  onChange: () => {},
  onOpen: () => {},
  hasFilterInput: false,
  showOnlyWhenFiltered: false,
  selectFirstMatchOnBlur: false,
  pushRoute: () => {},
  urlTransformer: (url, _segment) => url,
  isMsie: false,
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(AntDropdown)
